module.exports = __webpack_public_path__ + "img/crearistorante-text-logo.e595c16.svg";